import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const getInvoices = (state) => {
  
  return axios.get(API + "billing/create/invoice/"+state+"/",{headers: authHeader(),});
};
const editInvoices = (state,contract_id,duedate,description,notes,transaction_type,total_amount,rowsData,attribute, payment_method) => {

  return axios.post(API + "billing/create/invoice/" +state+"/", {
      contract_id,
      duedate,
      description,
      notes,
      transaction_type,
      total_amount,
      rowsData,
      attribute,
      payment_method   
  },{headers: authHeader(),});
};
const invoiceComplete = (state) => {
 
  return axios.get(API + "billing/invoice-complete/"+state+"/",{headers: authHeader(),});
};

const EditInvoicesService = {
    getInvoices,
    editInvoices,
    invoiceComplete
  };
  export default EditInvoicesService;